import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useAuth } from "@ssf/auth-components";
import { useSnackbar } from "notistack";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import { useCreateAutoAsked, useSignMembership } from "../lib/index.js";

export const AutoAskMembershipDialog = ({
  clubs,
}: {
  clubs: { id: number; name: string; existing?: boolean }[];
}) => {
  const { t } = useTranslation("AutoAskMembershipDialog");
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();
  const [open, setOpen] = useState(true);

  const { mutate: createAutoAsked } = useCreateAutoAsked({
    onSuccess() {
      enqueueSnackbar("Ditt val har sparats", { variant: "success" });
    },
  });
  const { mutate: signMembership } = useSignMembership({
    onError() {
      enqueueSnackbar("Något gick fel", { variant: "error" });
    },
    onSuccess() {
      enqueueSnackbar("Ditt medlemskap har sparats", { variant: "success" });
    },
  });

  return (
    <Dialog open={open && !!clubs?.length}>
      <DialogContent dividers sx={{ "> .MuiTypography-root": { mb: 1 } }}>
        <Typography variant="h3">{t("title", user?.profile || {})}</Typography>
        <Trans t={t} i18nKey="content" tOptions={{ postProcess: "markdown" }} />
        <Divider sx={{ mx: -3, my: 2 }} />
        <Typography>{t("hint")}</Typography>
        {clubs?.map((club) => (
          <FormControlLabel
            key={club.id}
            control={
              <Checkbox
                onChange={({ currentTarget }) => {
                  if (currentTarget.checked && user) {
                    signMembership({ clubId: club.id });
                    currentTarget.disabled = true;
                  }
                }}
              />
            }
            sx={{ display: "flex", my: -0.5 }}
            label={club.name}
          />
        ))}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between", ml: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={({ currentTarget }) => {
                if (currentTarget.checked && user) {
                  createAutoAsked({
                    by: "user",
                    memberId: Number(user.profile.sub),
                    type: "membership",
                  });
                  currentTarget.disabled = true;
                }
              }}
            />
          }
          label={t("dontAskAgain")}
        />
        <Button onClick={() => setOpen(false)}>{t("close")}</Button>
      </DialogActions>
    </Dialog>
  );
};
